import React, { useEffect, useState } from "react"; 
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";
import "swiper/css"
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay"; // optional, just for clarity
import { Navigation, Pagination, Autoplay } from "swiper/modules"; 
  const TestimonialHome = ({ typ="Hot"}) => {  
    const [listings, setListings] = useState([]);
    const [loading, setLoading] = useState(true);
  const API =  process.env.REACT_APP_API_URL || "https://nvrealestate.websiteseoonline.com";

    useEffect(() => {
      fetch(`${API}/api/testimonial.ashx`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({typ})
      })
        .then(res => res.json())
        .then(res => {
          if (res.result === 1) {          // <-- fixed here
            setListings(res.data);          // <-- set the array
          } else {
            console.error("Error:", res.message);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error(err);
          setLoading(false);
        });
    }, [typ]);
  
    if (loading) return <p>Loading client testimonials...</p>;
  
  return (
    <div className="wrap-categories-sw wow fadeInUp" data-wow-delay=".2s">
      <Swiper
        spaceBetween={30}
        slidesPerView={6}
        modules={[Navigation, Pagination,Autoplay]} 
        //navigation               // ✅ arrows
        pagination={{ clickable: true }}  // ✅ dots
         autoplay={{
          delay: 3000, // 3 seconds
          disableOnInteraction: false, // continue autoplay after user interaction
        }}
        breakpoints={{
          320: { slidesPerView: 1, spaceBetween: 15 },
          640: { slidesPerView: 2, spaceBetween: 15 },
          768: { slidesPerView: 2, spaceBetween: 30 },
          1024: { slidesPerView: 3, spaceBetween: 30 },
        }}
        className="tf-sw-categories"
      >
       {listings.map(item => (
       <SwiperSlide>
      <div className="review-card">
  <div className="review-header">
    <div className="rating"> 
      <div className="stars">★★★★★</div>
    </div> 
  </div>
  <div className="review-text">
   {item.description}
  </div>
  <div className="review-footer">
    <div className="reviewer-name">
      {item.fullname}
      <br />
     1 review
    </div>
    <div className="google-logo">
      <img src="/images/logo/google-review.png" alt="Google Review" style={{width:"100px"}} />
    </div>
  </div>
</div>

  </SwiperSlide>
    ))}
        {/* Add other SwiperSlide components here */}
      </Swiper>
    </div>
  );
}

export default TestimonialHome;
